import { PDFDocument, degrees } from 'pdf-lib';

export function documentPreviewKind(document = {}) {
  const type = document.type || document.mime_type || '';
  const name = document.name || document.file_name || document.external_url?.split(/[?#]/)[0] || '';
  if (type === 'application/pdf' || /\.pdf$/i.test(name)) return 'pdf';
  if (type.startsWith('image/') || /\.(png|jpe?g|webp|gif|bmp|avif)$/i.test(name) || document.document_type === 'image') return 'image';
  return null;
}

export async function rotateDocumentFile(file, clockwiseDegrees = 90) {
  const kind = documentPreviewKind(file);
  if (kind === 'pdf') {
    const pdf = await PDFDocument.load(await file.arrayBuffer());
    for (const page of pdf.getPages()) {
      page.setRotation(degrees(((page.getRotation().angle + clockwiseDegrees) % 360 + 360) % 360));
    }
    return new File([await pdf.save()], file.name || 'documento.pdf', { type: 'application/pdf' });
  }
  if (kind !== 'image') throw new Error('Solo se pueden girar imágenes y documentos PDF.');
  const bitmap = await window.createImageBitmap(file);
  try {
    const angle = ((clockwiseDegrees % 360) + 360) % 360;
    const swap = angle === 90 || angle === 270;
    const canvas = document.createElement('canvas');
    canvas.width = swap ? bitmap.height : bitmap.width;
    canvas.height = swap ? bitmap.width : bitmap.height;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('No se pudo preparar la imagen.');
    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate(angle * Math.PI / 180);
    context.drawImage(bitmap, -bitmap.width / 2, -bitmap.height / 2);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (!blob) throw new Error('No se pudo girar la imagen.');
    return new File([blob], `${(file.name || 'documento').replace(/\.[^.]+$/, '')}.png`, { type: 'image/png' });
  } finally { bitmap.close(); }
}
